import styled from 'styled-components'
import { Button } from '@usap/uicomponents'
import DifmLocation from '../constants/DifmLocation'

const buttonColor = '#25396C'
const buttonhoverColor = '#E0E3ED'

export const StyledShopSection = styled.section<{ isCart: boolean }>`
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  letter-spacing: 0.25px;
  border: ${({ isCart }) => (isCart ? 'none' : '1px solid #ADADAD')};
  border-top: ${({ isCart }) => (isCart ? '1px solid #EBEBEB' : '1px solid initial')};
  border-radius: ${({ isCart }) => (isCart ? '0' : '4px')};
  padding: ${({ isCart }) => (isCart ? 0 : '24px')};
  padding-top: ${({ isCart }) => (isCart ? '24px' : '16px')};
  padding-bottom: 16px;
  max-width: 584px;

  @media (max-width: 1024px) {
    max-width: 100%;
    padding: 12px;
    padding-top: ${({ isCart }) => (isCart ? '24px' : '12px')};
  }
`

export const StyledShopInfoWrapper = styled.div<{ pageName: DifmLocation }>`
  @media (max-width: 1024px) {
    padding-left: ${({ pageName }) => (['Cart', 'PDP'].includes(pageName) ? '12px' : 0)};
  }
`

export const StyledShopHeader = styled.header<{hideActionButtons: boolean}>`
  margin-bottom: 10px;
  cursor: ${({ hideActionButtons }) => (hideActionButtons ? 'default' : 'pointer')};
`

export const StyledShopPriceWrapper = styled.div`
  display: flex;
  font-weight: 700;
`

export const StyledShopAvgPriceWrapper = styled.div`
  display: flex;
  font-weight: 400;
  font-style: italic;
  color: #858585;
`

export const StyledPrice = styled.span`
  margin-left: auto;
  font-style: italic;
  &:after {
    content: '*';
    color: #CC3333;
  }
`

export const StyledPriceEmpty = styled.span`
  margin-left: auto;
`

export const StyledAppointmentWrapper = styled.div<{hideActionButtons: boolean}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: row;
  margin-bottom: 7px;
  cursor: ${({ hideActionButtons }) => (hideActionButtons ? 'default' : 'pointer')};
`

export const StyledAvailability = styled.span`
  color: #669944;
  letter-spacing: 0.25px;
  line-height: 16px;
  font-weight: 700;
  font-size: 14px;
  font-style: italic;
  display: inline-block;
  text-align: right;
`

export const StyledAvgPrice = styled.span`
  margin-left: auto;
  margin-right: 6px;
  letter-spacing: 0.25px;
  text-decoration-line: line-through;
  display: inline-block;
`

export const StyledShopAppointment = styled.span<{ disableBoldAppointmentTime?: boolean }>`
  font-weight: ${props => (props.disableBoldAppointmentTime ? 400 : 700)};
`

export const StyledShopName = styled.div<{hideActionButtons: boolean}>`
  font-weight: 700;
  margin-bottom: 4px;
  cursor: ${({ hideActionButtons }) => (hideActionButtons ? 'default' : 'pointer')};
`

export const StyledRating = styled.div<{hideActionButtons: boolean}>`
  display: flex;
  align-items: center;
  cursor: ${({ hideActionButtons }) => (hideActionButtons ? 'default' : 'pointer')};
  
  div:first-child{
    display: flex !important;
    
    svg {
      margin-right: 2px;
    }
  }
`

export const StyledShopAddress = styled.div<{hideActionButtons: boolean}>`
 font-size: 12px;
 letter-spacing: 0.4px;
 margin-bottom: 10px;
 margin-top: 4px;
 color: #141414;
 cursor: ${({ hideActionButtons }) => (hideActionButtons ? 'default' : 'pointer')};
`

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

//Restyling "Change appointment" button
  button:nth-child(2) {
    margin-left: 8px;
    width: 150px;
    padding: 0 5px;
  }
  
  @media(max-width: 350px){
    flex-direction: column;
    align-items: flex-start;
  }
`

export const StyledInstallButton = styled(Button)<{ isSelected: boolean, custom: boolean }>`
  background: ${({ isSelected }) => (isSelected ? buttonhoverColor : '#ffffff')};
  width: 165px;
  height: 32px;
  color: ${buttonColor};
  border: 1px solid ${buttonColor};
  box-shadow: none !important;
  pointer-events: auto;
  padding-right: 15px;
  padding-left: 10px;
  letter-spacing: 0.15px;
  font-size: 14px;
  white-space: nowrap;
  font-weight: 500 !important;
  flex-shrink: 0;

  &:hover {
    background: ${buttonhoverColor};
    color: ${buttonColor};
  }
`

export const StyledShopRatingLabel = styled.span`
  font-size: 12px;
`
